var HtmlComponent_default = {
  "htmlComponent": "_16xOD",
  "htmlComponent_placeholder": "FoQUz"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
